import { Box } from "@mui/material";
import { NoticeBoard } from "./NoticeBoard";
import { TodayCalendar } from "./TodayCalendar";

export function Top() {
    return (
        <Box sx={{ display: "flex" }}>
            {/* 左 */}
            <NoticeBoard />
            {/* 右 */}
            <TodayCalendar />
        </Box>
    );
}
